export enum PromoteFrameLocationTarget {
  TopCard = 'top-card',
  Template = 'template',
}

export enum PromoteFramePostMessageData {
  OpenVideoMakerAction = 'open-video',
  PromoteFrameLoadedAction = 'promote-frame-loaded',
}
